/**
 * getEvents
 * @module
 */
var _ = require('optimizely-client-fn');
var BehaviorStore = require('core/behavior/store');
var di = require('core/di');
var VisitorEventsStore = di.get('stores/visitor_events');

var LIMIT = 1000;

/**
 * Load events from all origins and concatenate with current origin events.
 * @returns {module:core/behavior/event~Event[]} Most recent LIMIT events from all sources
 */
exports.getEvents = function(): import('core/behavior/event').Event [] {
  var localEvents = BehaviorStore.getEvents();
  var allForeignEvents = [].concat.apply([], _.values(VisitorEventsStore.getForeignEvents()));
  var allForeignEventQueues = [].concat.apply([], _.values(VisitorEventsStore.getForeignEventQueues()));
  var allEvents = BehaviorStore.mergeAllEvents([
    localEvents,
    allForeignEvents,
    allForeignEventQueues,
  ]);
  return allEvents.slice(allEvents.length - LIMIT);
};
